// extracted by mini-css-extract-plugin
export var audioPlayer = "_qu-0";